import { withNamespaces } from "react-i18next";
import { useRef } from "react";
import OverviewHeader from "src/modules/data-protection/pages/admin/software/overview-header";
import { useQuery } from "@tanstack/react-query";
import DataProtectionSoftwareService from "src/modules/data-protection/apis/DataProtectionSoftwareService";
import { toast } from "react-toastify";
import ComplianceOverview from "./components/ComplianceOverview";
import ComplianceDecisionAnalysis from "./components/ComplianceDecisionAnalysis";
import ComplianceBlockers from "./components/ComplianceBlockers";
import ComplianceRecommendations from "./components/ComplianceRecommendations";
import ComplianceModules from "./components/ComplianceModules";
import ComplianceRisks from "./components/ComplianceRisks";
import ComplianceTasks from "./components/ComplianceTasks";
import ComplianceApprovals from "./components/ComplianceApprovals";
import ComplianceCeConformity from "./components/ComplianceCeConformity";

const Compliance = (props) => {
    const { t, assetId } = props;
    const overviewHeaderRef = useRef();

    const softwareDetailsQuery = useQuery({
        queryKey: ["gdpr-software-basic-information", assetId],
        queryFn: async () => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.details(assetId);
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: () => {
            toast(t("An error occurred while fetching software details."), {
                type: "error"
            });
        }
    });

    const complianceQuery = useQuery({
        queryKey: ["data-protection-fetch-compliance-content", assetId],
        queryFn: async () => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.fetchComplianceData(assetId);
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: () => {
            toast(t("An error occurred while fetching compliance content."), {
                type: "error"
            });
        }
    });

    return (
        <div className="p-4">
            <OverviewHeader
                assetId={assetId}
                actionsRef={overviewHeaderRef}
            />

            <ComplianceOverview
                complianceQuery={complianceQuery}
            />

            <ComplianceApprovals
                softwareDetailsQuery={softwareDetailsQuery}
                assetId={assetId}
            />

            <ComplianceCeConformity
                softwareDetailsQuery={softwareDetailsQuery}
                assetId={assetId}
            />

            <ComplianceModules
                complianceQuery={complianceQuery}
            />

            <ComplianceDecisionAnalysis
                complianceQuery={complianceQuery}
            />

            <ComplianceBlockers
                complianceQuery={complianceQuery}
            />

            <ComplianceRecommendations
                complianceQuery={complianceQuery}
            />

            <ComplianceRisks
                complianceQuery={complianceQuery}
                assetId={assetId}
            />

            <ComplianceTasks
                complianceQuery={complianceQuery}
                assetId={assetId}
            />
        </div>
    );
};

export default withNamespaces()(
    Compliance
);
